import React from "react"
import styled from "styled-components"
import { motion } from "framer-motion"
import { backgroundColor, breakpointLarge } from "../variables"

const topVariants = {
  idle: {
    y: -6,
    rotate: 0,
  },
  active: {
    y: 4,
    rotate: -45,
  },
}

const middleVariants = {
  idle: {
    scaleX: 1,
  },
  active: {
    scaleX: 0,
  },
}

const bottomVariants = {
  idle: {
    y: 6,
    rotate: 0,
  },
  active: {
    y: -4,
    rotate: 45,
  },
}

const ToggleButton = ({ toggleMobileNav, isMobileNavOpen }) => {
  return (
    <BurgerContainer onClick={toggleMobileNav}>
      <motion.div
        className="top"
        variants={topVariants}
        animate={isMobileNavOpen ? "active" : "idle"}
      />
      <motion.div
        variants={middleVariants}
        animate={isMobileNavOpen ? "active" : "idle"}
      />
      <motion.div
        className="bottom"
        variants={bottomVariants}
        animate={isMobileNavOpen ? "active" : "idle"}
      />
    </BurgerContainer>
  )
}

export default ToggleButton

const BurgerContainer = styled.div`
  div {
    height: 4px;
    width: 29px;
    background: ${backgroundColor};
  }

  @media (min-width: ${breakpointLarge}) {
    display: none;
  }
`
